import { ApiService } from "services/ApiService";
import { ApiUrl } from "services/ApiUrl";

const URL_API = ApiUrl.BASE;

const BeneficiosService = {

  async listar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/beneficios", params);
    return respuesta.data;
  },

  async exportar(params) {
    const respuesta = await ApiService(URL_API).get("/admin/comunicaciones-cultura/beneficios/exportar", {
      params: { ...params },
      responseType: "blob",
    });
    return respuesta;
  },

};

export { BeneficiosService };
